import { inject } from '@angular/core';
import { CanMatchFn, RedirectCommand, Router } from '@angular/router';
import { map } from 'rxjs';

import { AuthService } from '../auth/auth.service';
import { UiToastService } from '../ui/toast/toast.service';

export const unknownRouteRedirectGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  const toast = inject(UiToastService);
  const router = inject(Router);
  const redirect = new RedirectCommand(router.parseUrl('/app'));

  if (auth.isAuthenticated()) {
    toast.show({ tone: 'error', message: 'Page not found' });
    return redirect;
  }

  if (auth.status() === 'unauthenticated') {
    return redirect;
  }

  // Status is 'unknown' — probe session before deciding whether to show the toast.
  return auth.probeSession().pipe(
    map((authenticated) => {
      if (authenticated) {
        toast.show({ tone: 'error', message: 'Page not found' });
      }
      return redirect;
    }),
  );
};
